import React from 'react';
import HelpPageShell from '../../components/help/HelpPageShell';
import { realtorHelpContent } from '../../content/help/realtorHelpContent';

interface RealtorHelpPageProps {
  onNavigate: (screen: string) => void;
}

export default function RealtorHelpPage({ onNavigate }: RealtorHelpPageProps) {
  const origin = React.useMemo(() => {
    try { return sessionStorage.getItem('cb.help.origin') || 'realtor-dashboard'; } catch { return 'realtor-dashboard'; }
  }, []);

  const backLabel = origin === 'realtor-dashboard' ? '← Back to Dashboard' : '← Back';

  const handleBack = () => {
    try { sessionStorage.removeItem('cb.help.origin'); } catch {}
    onNavigate(origin);
  };

  return (
    <div>
      <div style={{ background: '#fff', borderBottom: '1px solid #e2e8f0', padding: '10px 24px' }}>
        <button
          onClick={handleBack}
          style={{
            background: 'none',
            border: '1px solid #cbd5e1',
            borderRadius: 8,
            padding: '7px 14px',
            fontSize: 14,
            fontWeight: 600,
            color: '#334155',
            cursor: 'pointer',
          }}
        >
          {backLabel}
        </button>
      </div>
      <HelpPageShell
        role="realtor"
        title="Realtor Help Center"
        subtitle="How referral links work, tracking your referrals, getting paid, and support."
        sections={realtorHelpContent}
        pendingSectionStorageKey="cb.realtor.help.section"
      />
    </div>
  );
}
